// extracted by mini-css-extract-plugin
module.exports = {"heading":"terms_heading__Uk2Xb","para":"terms_para__816f2","mb_10":"terms_mb_10__dp98L","mb_20":"terms_mb_20__7ma5b","table":"terms_table___J4Ng"};